import React from 'react';
import "../App.css";

export default function DeleteConfirmationModal({ isOpen, onClose, onConfirm }) {
    if (!isOpen) return null;

    return (
        <div className="agenda-modal-overlay">
            <div className="agenda-modal-content text-center p-4" style={{ maxWidth: '400px' }}>
                <h4 className="fw-bold mb-3 text-danger">Usuń Segment</h4>
                <p className="mb-4 text-secondary">
                    Czy na pewno chcesz usunąć ten segment? <br />
                    <strong>Wszystkie wiadomości z segmentu zostaną nieodwracalnie utracone.</strong>
                </p>

                <div className="d-flex justify-content-center gap-3">
                    <button
                        onClick={onClose}
                        className="btn btn-secondary rounded-pill px-4"
                    >
                        Anuluj
                    </button>
                    <button
                        onClick={onConfirm}
                        className="btn btn-danger rounded-pill px-4"
                    >
                        Usuń
                    </button>
                </div>
            </div>
        </div>
    );
}
